import { useMemo } from 'react';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { useClauseMap, useTextSearchInputClause } from '../index.tsx';

/**
 * Get the number of selected fields used in the jql including the text search field
 */
export const useNumberOfSelectedFields = () => {
	const clauseMap = useClauseMap();
	const textSearchInputClause = useTextSearchInputClause();

	return useMemo(
		() => Object.keys(clauseMap).length + (textSearchInputClause ? 1 : 0),
		[clauseMap, textSearchInputClause],
	);
};

export const useNumberOfSelectedFieldsWithFG = functionWithCondition(
	() => fg('filter_refinement_jql_analytics'),
	useNumberOfSelectedFields,
	() => 0,
);
